import React, { Component } from 'react'

import {CHOOSE_AN_OPTION_TEXT} from '../../../strings'

class CustomParkingPicker extends Component {

    render(){
        const {parkings, selectedParkingId, onParkingSelected, disabled} = this.props
        if (selectedParkingId === null){
            parkings[CHOOSE_AN_OPTION_TEXT] = {name: CHOOSE_AN_OPTION_TEXT}
        }
        return(
            <div className="container-custom-event-picker">
                <div className="line-header-text">Parqueos registrados</div>
                <select
                    className="select-css"
                    value={selectedParkingId ? selectedParkingId : CHOOSE_AN_OPTION_TEXT}
                    onChange={onParkingSelected}
                    disabled={disabled}
                >
                {
                    Object.keys(parkings).map(key => {
                        return (
                            <option value={key} key={key}>{parkings[key].name}</option>
                        )
                    })
                }
                </select>
            </div>
        )
    }
}

export default CustomParkingPicker
